export default __webpack_public_path__ + "static/media/img_mv_program_illustration_x3.03b9f211.png";